<template>
    <div class="container-login form-login-meio">
        <div class="p-d-flex p-jc-center"> 
            <div>
                <div class="p-d-flex p-jc-center p-mb-5">
                    <a href="/login">
                        <img alt="Logo" src="@/assets/logo.png" />
                    </a>
                </div>
                <div class="card p-fluid p-shadow-3" style="width: 25rem;">
                    <h5 class="p-pt-4 p-d-flex p-jc-center">Redefinir senha</h5>   
                    <div class="p-field" v-if="exibirCampos">					
                         <span class="p-input-icon-left">
                            <i class="pi pi-user"/>                       
                            <InputText v-model.trim="email" type="text" placeholder="Email" aria-describedby="email-erro"  readonly/>                            
                        </span>                         
                    </div>               
                    <div class="p-field p-mt-4" v-if="exibirCampos">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-lock" />                       
                            <InputText v-model.trim="senha" type="password" placeholder="Nova senha" aria-describedby="email-erro" />                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="senha === '' && enviandoForm">Informe a senha</small>  
                    </div>
                    <div class="p-field">					
                        <span class="p-input-icon-left" v-if="exibirCampos">
                            <i class="pi pi-lock" />                       
                            <InputText v-model.trim="repetirSenha" type="password" placeholder="Repetir senha" aria-describedby="email-erro" />                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="repetirSenha === '' && enviandoForm">Informe a senha</small>  
                        <div class="p-grid p-d-flex p-jc-between p-mt-2" v-if="exibirCampos">
                            <div class="p-col-6 p-text-left">
                                <a href="#" @click="irLogin" class="text-help">Login</a> 
                            </div> 
                            <div class="p-col-6 p-text-right">                               
                            </div>                                                   
                        </div>
                    </div>   
                    <div class="p-grid p-mb-4">
                        <div class="p-col-12">
                            <Button label="Enviar" @click="enviar"/>
                        </div>
                    </div>	
                    <Message severity="error" v-if="mensagemErro !== ''">{{ mensagemErro }}</Message>
                    <Message severity="success" v-if="mensagemSucesso !== ''">{{ mensagemSucesso }}</Message>
                </div>
                <div class="p-text-center" style="color:#F9B720">Info Kings</div>
                <div v-if="exibirSpin" class="p-text-center"><i class="pi pi-spin pi-spinner" style="fontSize: 2rem; color:#F9B720"></i></div>
            </div>
        </div>
    </div> 
</template>

<script>
import RevendedorService from '@/service/RevendedorService';

export default {
    revendedorService: null,    
    data() {
        return {
            exibirCampos: false,            
            exibirSpin: false,
            enviandoForm: false,           
            mensagemErro: '',
            mensagemSucesso: '',            
            email: '',
            senha: '',
            repetirSenha: '',  
            revendedor: null,         
        }
    },    
    methods: {
        enviar() {
            this.exibirSpin = true;
            this.enviandoForm = true;         
            this.mensagemSucesso = '';
            this.mensagemErro = '';                         
            if(this.senha != '' && this.repetirSenha != '') {         
                let dados = {                   
                    senha: this.senha,
                    senhaIgual: this.repetirSenha,
                    revendedor: this.revendedor,                    
                }   
                this.revendedorService.alterarSenha(dados)
                    .then(resp => {
                        this.exibirCampos = false;
                        this.exibirSpin = false;                       
                        this.mensagemSucesso = resp.data.mensagem;
                    })
                    .catch(erro => {       
                        this.exibirSpin = false;     
                        this.mensagemErro = erro.response.data.mensagem;
                    });               
            } else {
                this.exibirSpin = false;
            }           
        },
        validarSessao() {
            let json = sessionStorage.getItem('REVENDEDOR_REDEFINIR_SENHA');             
            sessionStorage.removeItem('REVENDEDOR_REDEFINIR_SENHA');      
            if(!json) {               
                this.$router.push('/login');                
            } else {                
                this.exibirCampos = true;
                this.revendedor = JSON.parse(json);
                this.email = this.revendedor.email;               
            }
        },
        irLogin() {
            this.$router.push('/login');
        }
    },
    created() {
        this.revendedorService = new RevendedorService();    
        this.validarSessao();        
    }
}
</script>

<style scoped>    
    
    html, body {
        height: 100vh !important;
        margin: 0px !important;  
    }

    .container-login {
        height: 100vh !important;
        background-color: #232839 !important;
    }

    .form-login-meio {
        padding-top: 130px;
    }

    .text-help {
        font-size: 0.9rem !important;
    }

</style>